import axios from "axios";

export default {
  namespaced: true,
  state: {
    materials: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    materialsMessage: ''
  },
  mutations: {
    RECEIVED_MATERIALS(state, payload) {
      state.materials = payload;
      state.isReceiving = false;
    },
    RECEIVING_MATERIALS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MATERIAL(state, payload) {
      state = Object.assign(state, {
        materials: [...state.materials, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MATERIAL(state) {
      state.isReceiving = true;
    },
    UPDATED_MATERIAL(state, payload) {
      let index = state.materials.findIndex(material => material._id === payload._id);
      state = Object.assign(state, {
        materials: state.materials.map((material, i) => {
          if (i === index) {
            return Object.assign({}, material, payload);
          }
          return material;
        }),
        isUpdating: false,
        materialsMessage: 'Materials has been updating!',
      })
    },
    UPDATING_MATERIAL(state) {
      state.isUpdating = true;
    },
    DELETED_MATERIAL(state, payload) {
      let indexToDelete = state.materials.findIndex(material => material._id === payload._id);
      console.log(indexToDelete);
      let materials = [...state.materials];
      materials.splice(indexToDelete, 1);
      state = Object.assign(state, {
        materials: [...materials],
        isDeleting: false,
        idToDelete: null,
        materialsMessage: 'Material has been Deleted!',
      });
    },
    DELETING_MATERIAL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteMaterialRequest({dispatch}, payload) {
      dispatch("deletingMaterial", payload);
      axios.delete('https://api.tradexc.com:3000/delete/material/' + payload._id)
      .then(response => {
        dispatch("deleteMaterial", response.data);
      })
    },
    async deleteMaterialDetailRequest({dispatch}, payload) {
      try{
        dispatch("updatingMaterial");
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/materialdetail/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        console.log(response.data);
        dispatch("updateMaterial", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    getMaterialsRequest({dispatch}) {
      dispatch("receivingMaterials");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/materials';
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveMaterials", response.data);
      })
    },
    updateMaterialRequest({dispatch}, payload) {
      dispatch("updatingMaterial");
      var id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/material/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: header, data: payload})
      .then(function (res) {
        dispatch("updateMaterial", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateMaterialImageRequest({dispatch}, payload) {
      dispatch("updatingMaterial");
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/material/image/' + id;
      let data = new FormData();
      data.append('image', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);
      let header = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: header, data: data})
      .then(response => {
        dispatch("updateMaterial", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    insertMaterialRequest({dispatch}, payload) {
      dispatch("receivingMaterials");
      var token = localStorage.getItem('token');    
      let url = 'https://api.tradexc.com:3000/insert/material';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveMaterial", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertMaterialWithImageRequest({dispatch}, payload) {
      console.log(payload)
      dispatch("receivingMaterials");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/material/withimage';
      let data = new FormData();
      data.append('image', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);
      let headers = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveMaterial", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },

    receiveMaterials({commit}, payload) {
      commit("RECEIVED_MATERIALS", payload)
    },
    receivingMaterials({commit}) {
      commit("RECEIVING_MATERIALS")
    },
    receiveMaterial({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_MATERIAL", payload)
    },
    receivingMaterial({commit}) {
      commit("RECEIVING_MATERIAL")
    },
    updateMaterial({commit}, payload) {
      commit("UPDATED_MATERIAL", payload)
    },
    updatingMaterial({commit}) {
      commit("UPDATING_MATERIAL")
    },
    deleteMaterial({commit}, payload) {
      commit("DELETED_MATERIAL", payload)
    },
    deletingMaterial({commit}, payload) {
      commit("DELETING_MATERIAL", payload)
    }
  },
};
